import { accountIdFormat } from "@redotech/redo-account-id";
import {
  locationIdFormat,
  supplierIdFormat,
} from "@redotech/redo-inventory-id";
import * as z from "zod";

export const CrdbLocationSchema = z.object({
  id: locationIdFormat.schema,
  name: z.string(),
  externalId: z.string().nullish(),
  accountId: accountIdFormat.schema.nullish(),
  supplierId: supplierIdFormat.schema.nullish(),
  address: z
    .object({
      street1: z.string().nullish(),
      street2: z.string().nullish(),
      city: z.string().nullish(),
      state: z.string().nullish(),
      postalCode: z.string().nullish(),
      country: z.string().nullish(),
    })
    .nullish(),
});

export type CrdbLocation = z.infer<typeof CrdbLocationSchema>;

export const getCrdbLocations = {
  name: "getCrdbLocations" as const,
  input: z
    .object({
      onlyWithWarehouseLayout: z.boolean().optional(),
      // For 3PL teams: also include warehouse locations owned by their managed
      // merchant accounts, not just the 3PL's own account.
      includeManagedMerchantLocations: z.boolean().optional(),
    })
    .nullable(),
  output: z.object({ locations: z.array(CrdbLocationSchema) }),
};
